<script>
import Vue from 'vue';
import { BarcodeGeneratorPlugin } from "@syncfusion/ej2-vue-barcode-generator";
Vue.use(BarcodeGeneratorPlugin);
export default {
    name: "ViewBarCode",

    data() {

        return {
            patient: {},
            prescriptionHistory: [], 
            width: "200px",
         height: "150px",
         mode: "SVG",
         type: "Code128A",
         value: "SYNCFUSION",
        };
    },

    mounted() {
        this.$root.loading = true;
        Promise.all([ this.fetchPatient(), this.fetchPrescriptions(), ]).then(() => {
            this.$root.loading = false;
            setTimeout(() => {
                window.print();
            }, 200);
        }).catch(() => { this.$root.loading = false; });
    },

    methods: {

        fetchPatient() {

            let url = `PatientRegistration/GetSpecificPatient`;
                url += `?PatientID=${this.$route.query.patient}`;

            return this.$http.get(url).then(({ data }) => {
                this.patient = data.length ? data[0] : {};
                this.patient.code=`${this.$route.query.patientInvestigationId}`;
            }).catch(() => {});
        },

        fetchPrescriptions() {
            let url = `Lab/GetPatientPendingSpecificLabInvestigation`;
                url += `?InvestigationID=${this.$route.query.patientInvestigationId}`;

            return this.$http.get(url).then(response => {
                this.prescriptionHistory = response.data;
                this.$root.loading = false;
            }).catch(() => { this.$root.loading = false; });
        },
       
    },
}
</script>
<template>
<div class="w-1/4 flex flex-wrap items-center">
    <!-- <tail-address-header></tail-address-header> -->
    <div class="w-full flex flex-wrap content-start border-2 mb-2">
        <div class="sm:w-full md:w-3/12">
        <ejs-barcodegenerator
          id="barcode"
          invalid="invalidInput"
          ref="barcodeControl"
          :width="width"
          :height="height"
          :type="type"
          :value="patient.code"
          :mode="mode"
        ></ejs-barcodegenerator>
      </div>  <div class="sm:w-full p-tiny">
          <h5 style="font-size: .6rem;">Name: {{ patient.names }} Test:{{prescriptionHistory[0].investigation}}</h5>
        </div>
        <!-- <div class="w-1/4 p-tiny">
          <h5 class="font-medium text-sm">IP File No: {{ patient.ipfileno || `-` }}</h5>
        </div>
        <div class="w-1/4 p-tiny">
          <h5 class="font-medium text-sm">OP File No: {{ patient.opfileno || `-` }}</h5>
        </div>
        <div class="w-1/4 p-tiny">
          <h5 class="font-medium text-sm">Gender: {{ patient.gender }}</h5>
        </div>
        <div class="w-1/4 p-tiny">
          <h5 class="font-medium text-sm">DOB: {{ patient.dob | dateFormat }}</h5>
        </div>
        <div class="w-1/4 p-tiny">
          <h5 class="font-medium text-sm">MRN: {{ patient.patienT_ID }}</h5>
        </div>
        <div class="w-1/4 p-tiny">
          <h5 class="font-medium text-sm"> Visit No: {{ patient.visitNo }}</h5>
        </div> -->
    </div>
   
</div>
</template>